import { observer } from "mobx-react-lite";
import { FC } from "react";
import { useStore } from "store";
import type { FilterType } from "types/menu";

const MenuFilterItem: FC<{ name: FilterType }> = observer(({ name }) => {
	const { menu } = useStore();
	return (
		<button
			className={`rotate-[270deg] ${
				menu.activeFilter === name ? "bg-primary border-transparent" : "border-primary"
			} px-2 py-1 text-center rounded border-2`}
			onClick={() => menu.setActiveFilter(name)}
		>
			{name}
		</button>
	);
});

const MenuFilter: FC = () => {
	return (
		<div className="flex flex-col py-4 ml-1 space-y-10">
			<MenuFilterItem name="Food" />
			<MenuFilterItem name="Drinks" />
			<MenuFilterItem name="Others" />
			<MenuFilterItem name="All" />
		</div>
	);
};
export default MenuFilter;
